'use strict';

import React from 'react';
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
//import {isTrue} from "./Utils";

export const render = (router) => {
    const appContainer = document.getElementById('react_app');
    const root = createRoot(appContainer);
    root.render(router);

    /*
    if ( isTrue(process.env.axe) ) {
        const interval = 8000;
        // NOTE: Have to add dependency back if you want to use it.
        const axe = require('@axe-core/react');
        const axeConfig = {
            rules: [
                // Gives error about content outside landmarks, but rule specifies skip to main
                // links as an except to this rule, but that's the only thing triggering this error
                { id: 'region', enabled: false },
                { id: 'meta-viewport', enabled: false }
            ]
        };
        const timer = setInterval(() => {
            axe(React, ReactDOM, interval, axeConfig);
        }, interval);
        root.render(router);
        // clearing interval
        return () => clearInterval(timer);
    } else {
        root.render(router);
    }
     */
}